import { createFileRoute } from "@tanstack/react-router";
import CignaInsurance, { config } from "@/pages/CignaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/cigna-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Cigna TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Have Cigna insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Cigna plan in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Cigna TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Have Cigna insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Cigna plan in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/cigna-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/cigna-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CignaInsurance />;
}
